import Vue from "vue";
import App from "@/App.vue";

// registering vue-router hooks for typescript vue-class-component
// https://github.com/vuejs/vue-class-component#adding-custom-hooks
import "@/classComponentsHooks";

// import fontawesome from "@fortawesome/fontawesome";
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from "@fortawesome/vue-fontawesome";
Vue.component("font-awesome-icon", FontAwesomeIcon as any);
Vue.component("font-awesome-layers", FontAwesomeLayers as any);
Vue.component("font-awesome-layers-text", FontAwesomeLayersText as any);
// loading and setting fontawesome svg icons
// do not delete even though it is not used!!!
// tslint:disable-next-line:no-var-requires
const fontawesome = require("@/fontawesome.ts");

import "@/plugins/vuetify";
import { MUTATIONS } from "@/models/vuex-types";
// initializing Firebase
import { auth } from "@/firebaseConfig";
import router from "@/router";
import i18n from "@/i18n";
import store from "@/store";
import VueFirestore from "vue-firestore";
Vue.use(VueFirestore);

// rules for routing according to authentication
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((route) => route.meta.requiresAuth);
  const requiresEmailVerification = to.matched.some((route) => route.meta.requiresEmailVerification);

  // send user to landing page as he is not signed in
  if (requiresAuth && !store.state.currentUser) {
    next("/");

    // send user to email verification page as he has not verified his email yet
  } else if (requiresAuth && store.state.currentUser && requiresEmailVerification && !store.state.currentUser.emailVerified) {
    next({ path: "/email-verification-required", query: { redirect: to.fullPath }});

    // signed in - let him through
  } else if (requiresAuth && store.state.currentUser) {
    next();

    // send user to overview page instead of landing page
  } else if ((to.path === "/" || to.path === "/signed-out") && store.state.currentUser) {
    next("/event/overview");

  } else {
    next();
  }
});

// const faIconHelperSelect = require("@/directives/fa-icon-helper-select-checkbox.ts");
// tslint:disable-next-line:no-var-requires
// const faIconHelper = require("@/directives/fa-icon-helper-radio.ts");
// tslint:disable-next-line:no-var-requires

// TODO: Create two entry points of application - one initialized without auth and one for auth required
let app: Vue;

// checking on auth changes and assigning current user if there is any
auth.onAuthStateChanged((user) => {
  store.commit(MUTATIONS.SET_CURRENT_USER, user);

  // initialize Vue inside the callback so that firebase is initialized already and we know if user is signed in or not
  if (!app) {
    Vue.config.productionTip = false;
    app = new Vue({
      router,
      i18n,
      store,
      render: (h) => h(App),
    });

    app.$mount("#app");
  }
});
